// extracted by mini-css-extract-plugin
export default {"container":"upWorld__container__tnRs7","hide":"upWorld__hide__H8gPe","scene":"upWorld__scene__Mz4qe"};